import React, { useContext } from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import ProposalView from "./Components/ProposalView/ProposalView";
import PropView from "./Components/PropView/PropView";
import RoofProp from "./Components/PropView/components/RoofProp";

import RepDash from "./Components/RepDash/RepDash";
import Admin from "./Components/Admin/Admin";
import LoanProducts from "./Components/LoanProducts/LoanProducts";
import Utilities from "./Components/Utilities/Utilities";
import ShadeWaiver from "./Components/ShadeWaiver/ShadeWaiver";
import CustProposalView from "./Components/ProposalView/CustProposalView";
import Login from "./Components/Auth/Login";
import { UserContext } from "./UserContext";

import awsconfig from "./aws-exports";
import { I18n, Auth } from "aws-amplify";
import { Translations } from "@aws-amplify/ui-components";
import PrivateRoute from "./Components/Auth/PrivateRoute";

// This is the main routes file...

Auth.configure(awsconfig);

function Routes() {
  // console.log(window.location.search)

  const { authState, setAuthState, activeUser, setActiveUser } =
    useContext(UserContext);

  I18n.putVocabulariesForLanguage("en-US", {
    [Translations.FAMILY_NAME_LABEL]: "Last Name",
    [Translations.FAMILY_NAME_PLACEHOLDER]: "Enter your last name",
    [Translations.GIVEN_NAME_LABEL]: "First Name",
    [Translations.GIVEN_NAME_PLACEHOLDER]: "Enter your first name",
  });

  return (
    <HashRouter>
      <Switch>
        <Route path="/login" component={Login} />
        <Route
          path="/custproposalview/:prop_id/:number"
          component={CustProposalView}
        />
        <Route
          path="/customerproposalview/:prop_id/:number/:view"
          component={ProposalView}
        />
        <Route
          path="/customerpropview/:prop_id/:number/:view"
          component={PropView}
        />
        <Route path="/roofProp/:quote_id" component={RoofProp} />
        <PrivateRoute path="/" exact component={Dashboard} />
        <PrivateRoute
          path="/proposalview/:prop_id/:number/:view"
          component={ProposalView}
        />
        <PrivateRoute
          path="/propview/:prop_id/:number/:view"
          component={PropView}
        />
        <PrivateRoute path="/loanProducts" component={LoanProducts} />
        <PrivateRoute path="/utilities" component={Utilities} />
        <PrivateRoute path="/shade/:prop_id" component={ShadeWaiver} />
        <PrivateRoute path="/admin" component={Admin} />
        <PrivateRoute path="/repdashboard" component={RepDash} />
      </Switch>
    </HashRouter>
  );
}

export default Routes;
